/* === Safe Storage Patch === */
(function () {
  function safeProxy(storage) {
    return new Proxy(storage, {
      get(target, prop) {
        if (['getItem','setItem','removeItem','clear','key','length'].includes(prop)) {
          return function (...args) {
            try {
              return target[prop](...args);
            } catch (e) {
              if (!window.__safeStorageLogged) {
                console.warn(`SafeStorage: ${prop} blocked`, e);
                window.__safeStorageLogged = true;
              }
              return null;
            }
          };
        }
        return target[prop];
      }
    });
  }
  try { window.localStorage = safeProxy(window.localStorage); } catch (e) {
    console.warn('SafeStorage: localStorage inaccessible', e);
  }
  try { window.sessionStorage = safeProxy(window.sessionStorage); } catch (e) {
    console.warn('SafeStorage: sessionStorage inaccessible', e);
  }
})();

/* === Safe MutationObserver Patch === */
(function () {
  const OriginalObserver = window.MutationObserver;
  window.MutationObserver = function (callback) {
    const observer = new OriginalObserver(callback);
    const originalObserve = observer.observe;
    observer.observe = function (target, options) {
      if (!(target instanceof Node)) {
        console.warn('SafeObserver: tried to observe a non-Node target. Skipping.');
        return;
      }
      try {
        return originalObserve.call(observer, target, options);
      } catch (e) {
        console.warn('SafeObserver: observe error', e);
      }
    };
    return observer;
  };
})();
